import { Button, Card, CardBody, CardFooter, CardHeader } from '@nextui-org/react';
import { RHFSelect, TWTextField } from '@commons/hook-form';
import { errorOrders, Roles, translates } from '@/utils';
import { MenuItem } from '@mui/material';
import { Button as ButtonPorky } from '@PorkyCol/button';
import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { createOrdersService, findUsersByBranch } from '@/services';
import { useFormContext } from 'react-hook-form';
import { Iconic } from '@/commons/iconic';
import { useDrawers } from '@/hooks/useDrawers';
import { set } from 'husky';
import { useFetch } from '../../hooks/useFetch';
import { PATH_DASHBOARD } from '@/routes/paths';
import { useNavigate } from 'react-router-dom';

type Props = {
  isAvailableVendor: boolean;
  isFoodCompany: boolean;
  isLoading: boolean;
  isValid: boolean;
};

export const OrderFacturePreview = ({
  isAvailableVendor,
  isFoodCompany,
  isLoading,
  isValid,
}: Props) => {
  const { setValue, watch, resetField } = useFormContext();
  const { onOpen: onOpenCart, onChangeLoading } = useDrawers();

  const navigate = useNavigate()
  const items = watch()?.items ?? [];
  const { data: dataUsers } = useQuery({
    queryKey: ['users'],
    queryFn: findUsersByBranch,
    select: (dataTemp: any) =>
      dataTemp.filter(
        (item: { status: any; rol: { id: Roles } }) =>
          item.status &&
          !!item.rol &&
          (item.rol?.id === Roles.WAITRESS ||
            item.rol?.id === Roles.ATM ||
            item.rol.id === Roles.ADMIN ||
            item.rol.id === Roles.SUPER_ADMIN)
      ),
  });
  const handlePressMinus = (index: any, productId: string) => {
    const existingProduct = items[index];

    if (existingProduct) {
      if (existingProduct.quantity > 1) {
        setValue(
          `items[${index}].quantity`,
          // eslint-disable-next-line no-unsafe-optional-chaining
          items[index]?.quantity - 1 || 1
        );
      } else {
        setValue(
          'items',
          items.filter((p: any, i: any) => i !== index)
        );
      }
    }
  };
  const handlePressMax = (index: any, productId: string) => {
    const existingProduct = items[index];
    if (existingProduct) {
      return setValue(
        `items[${index}].quantity`,
        // eslint-disable-next-line no-unsafe-optional-chaining
        items[index]?.quantity + 1 || 1
      );
    }
  };

  const dataDrawer = {
    data: watch,
    users: dataUsers,
    handlePressMax: handlePressMax,
    handlePressMinus: handlePressMinus,
    isFoodCompany,
    loading: isLoading,
    disabled: isValid,
    isAvailableVendor,
    setValue,
    setItems: (items = []) => setValue('items', items),
  };

  const {
    fetchValues: onSubmitCreateOrder,
    // data: dataCreateOrder,
  } = useFetch({
    fetchFunction: createOrdersService,
    getData: true,
  });
  
  const onCreateOrdersService = async (values: any) => {
    try {
      const resolve = await onSubmitCreateOrder(values);
      if (resolve.error) {
        const errorMessage =
          errorOrders[resolve?.error ?? resolve?.error.message] ?? 'Problemas Añadiendo Productos';
        enqueueSnackbar(`${errorMessage.label ?? errorMessage} `, { variant: 'error' });
      } else {
        navigate(PATH_DASHBOARD.orders.view(resolve?.id));
      }
    } catch (error) {
      const errorMessage = errorOrders[error?.error.message] ?? 'Problemas Añadiendo Productos';
      enqueueSnackbar(`${errorMessage.label ?? errorMessage} `, { variant: 'error' });

      if (error.data) enqueueSnackbar(`${error.data.name} `, { variant: 'info' });
      if (errorMessage.redirect) {
        navigate(PATH_DASHBOARD.orders.open_orders);
      }
      throw new Error(error);
    }
  };


  const onSubmit = async (dataForm: any) => {
    try {
      const { items, ...rest } = watch();
      console.log('🚀 ~ CreateSimpleOrder ~ dataForm', dataForm);
      const valuesFormatted = dataForm.items.map((item: any) => {
        if (item.quantity + item.discountNumber < 1) {
          throw null;
        }

        const discountFlag = item.discountNumber > 0 && item.discount > 0;
        return {
          productId: Number(item.id),
          quantity: Number(item.quantity),
          description: item.description,
          discount: {
            discount: Number(discountFlag ? item.discount : 0),
            quantity_discount: Number(discountFlag ? item.discountNumber : 0),
          },
        };
      });
      console.log('🚀 ~ CreateSimpleOrder ~ valuesFormatted', {
        ...rest,
        ordersDetails: valuesFormatted,
      });
      await onCreateOrdersService({ ...rest, ordersDetails: valuesFormatted });
    } catch (error) {
      const errorMessage = new Error(error?.message);

      throw errorMessage;
    }
  };


  return (
    <>
      <div className="flex sm:hidden fixed bottom-2 right-2 z-[49]">
        <Button
          variant="shadow"
          type="button"
          radius="full"
          color="primary"
          size="lg"
          isIconOnly
          onPress={() => onOpenCart('car', dataDrawer)}
        >
          <Iconic icon="mdi:shopping-cart-outline" width={25} />
        </Button>
      </div>
      <div className="hidden sm:flex sm:w-full sm:min-h-[40rem] sm:max-h-[40rem] p-1 ">
        <Card
          className="max-w-[400px] p-5 shadow-none"
          style={{ minHeight: '300px', maxHeight: '610px', minWidth: '450px' }}
        >
          <CardHeader>
            <h4 className="text-xl font-semibold leading-none w-full">Factura de venta</h4>
            {isAvailableVendor ? (
              <RHFSelect
                name="vendor"
                size="small"
                label={isFoodCompany ? translates.waiter : 'Vendedor'}
                sx={{ height: '100%' }}
                InputProps={{ style: { height: '100%' } }}
                InputLabelProps={{ shrink: true }}
              >
                {dataUsers?.map?.((service: any) => (
                  <MenuItem key={service.id + service.name} value={service.id}>
                    {service.name}
                  </MenuItem>
                ))}
              </RHFSelect>
            ) : (
              <div />
            )}
          </CardHeader>
          <CardBody className="py-2">
            <div className="divide-y">
              {watch()?.items?.map((product: any, index: React.Key | null | undefined) => (
                <div key={index} className="flex justify-between items-center py-1">
                  <div>
                    <p className="font-semibold p-0 m-0 h-fit">{product.name}</p>
                    {product?.description && (
                      <caption className="text-xs text-default-400">{product.description}</caption>
                    )}
                    <p className="text-sm text-default-400">{product.price.toLocaleString()} </p>
                  </div>
                  <div className="flex items-center gap-3 ml-3">
                    <Button
                      isIconOnly
                      className="rounded-full h-5 w-5 min-w-5"
                      color="primary"
                      onPress={() => handlePressMinus(index, product.id)}
                    >
                      -
                    </Button>
                    <span>{product.quantity}</span>
                    <Button
                      isIconOnly
                      className="rounded-full h-5 w-5 min-w-5 flex justify-center items-center text-center p-0"
                      color="primary"
                      onPress={() => handlePressMax(index, product.id)}
                    >
                      +
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          </CardBody>
          <CardFooter className="flex items-center justify-between">
            <ButtonPorky
              type="submit"
              variant="solid"
              color="success"
              size="sm"
              loading={isLoading}
              disabled={!isValid}
              onClick={onSubmit}
            >
              Crear orden
            </ButtonPorky>

            <TWTextField
              className="w-1/2"
              name="table"
              label={isFoodCompany ? 'Mesa' : translates.table}
              placeholder={isFoodCompany ? 'Mesa 01' : 'Nombre del cliente'}
            />
          </CardFooter>
        </Card>
      </div>
    </>
  );
};
function enqueueSnackbar(arg0: string, arg1: { variant: string; }) {
  throw new Error('Function not implemented.');
}

